export default "__VITE_ASSET__imzvygN2__"